import React from "react";
import { styled } from "styled-components";
const Container = styled.div `
  padding: 0 1.25rem 0.75rem;

  > p {
    margin: 0;
  }
`;
const PriceRadioBoxBody = ({ description, }) => (React.createElement(Container, null,
    React.createElement("p", null, description)));
export default PriceRadioBoxBody;
//# sourceMappingURL=PriceRadioBoxBody.js.map